import gql from 'graphql-tag';
import { getCounterpartyId } from '../../../services/authService';

export const getAllCounterpartyQuery = gql`
  {
  allCounterParty(tenantId: "${getCounterpartyId()}") {
    id 
    counterPartyId 
    code
    shortName
    longName
    }
  }
`;
